import React, { useState, useEffect } from 'react';
import { Icon } from './Icon';

interface CloseButtonProps {
  onClick: () => void;
  size?: 'standard' | 'small';
  className?: string;
  style?: React.CSSProperties;
}

const CloseButton: React.FC<CloseButtonProps> = ({ 
  onClick, 
  size = 'standard', 
  className = '',
  style = {}
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Responsive sizing
  const getButtonSize = () => {
    if (isMobile) {
      return size === 'small' ? 28 : 24;
    }
    return size === 'small' ? 32 : 40;
  };

  const getIconSize = () => {
    if (isMobile) {
      return size === 'small' ? 18 : 16;
    }
    return size === 'small' ? 20 : 24;
  };

  const buttonSize = getButtonSize();
  const iconSize = getIconSize();

  const buttonStyle: React.CSSProperties = {
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: `${buttonSize}px`,
    height: `${buttonSize}px`,
    borderRadius: '50%',
    background: 'var(--c-text-primary)',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    transition: 'all 0.2s ease',
    ...style
  };

  return (
    <button
      className={className}
      style={buttonStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'white';
        e.currentTarget.style.color = 'var(--c-text-primary)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'var(--c-text-primary)';
        e.currentTarget.style.color = 'white';
      }}
      aria-label="Close"
    >
      <Icon name="X" size={iconSize} />
    </button>
  );
};

export default CloseButton;